import React from 'react';

const PromoIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="23"
    height="21"
    viewBox="0 0 23 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.6113 13.928L14.7583 17.6466C15.1725 18.364 14.9267 19.2814 14.2092 19.6956C13.4918 20.1099 12.5744 19.864 12.1602 19.1466L9.50663 14.5505M17.9055 2.82986L18.2715 1.46384M19.9055 6.29398L21.2715 6.66M6.54926 15.16L17.168 12.7285C18.4796 12.4282 19.1264 10.9443 18.4536 9.77899L14.1615 2.34488C13.4887 1.17955 11.8803 0.997752 10.9643 1.98351L3.54926 9.96386L6.54926 15.16ZM3.79929 10.3968L6.29929 14.727C6.7135 15.4444 6.46769 16.3618 5.75025 16.776C5.03281 17.1902 4.11543 16.9444 3.70121 16.227L1.20121 11.8968C0.786999 11.1794 1.03281 10.262 1.75025 9.84781C2.46769 9.4336 3.38507 9.67941 3.79929 10.3968Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PromoIcon; 